import script from "./PlanFormPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFormPanel.vue?vue&type=script&setup=true&lang=js"

import "./PlanFormPanel.vue?vue&type=style&index=0&id=6796dc6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6796dc6a"]])

export default __exports__